import teras from '@/teras'

import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'

import ContattoEdit from '@/components/Contatto-edit'
import ContattoPassword from '@/components/Contatto-password'
import ContattoRinnovo from '@/components/Contatto-rinnovo'
import SellaBack from '@/components/Sella-back'

Vue.use(VueRouter)

var mode = (process.env.NODE_ENV != 'development') ? 'history' : 'hash'

const router = new VueRouter({

  mode: mode,
  base: '/tesoreria/',

  scrollBehavior (to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 500)
    })
  },

  routes: [
    { path: '/',  redirect: '/home'},
    { path: '/login', name: 'login', meta: { requiresAuth: false }, components:{main: Login  } }, 
    { path: '/home', name: 'home', meta: { requiresAuth: true }, components:{main: Home  }}, 

    { path: '/contatto-edit', name: 'contatto.edit', meta: { requiresAuth: true }, components: { main: ContattoEdit } }, 
    { path: '/contatto-password', name: 'contatto.password', meta: { requiresAuth: true }, components: { main: ContattoPassword } }, 
    { path: '/contatto-rinnovo', name: 'contatto.rinnovo', meta: { requiresAuth: true }, components: { main: ContattoRinnovo } },
    { path: '/sella-back', name: 'sella.back', meta: { requiresAuth: false }, components:{main: SellaBack  } }, 

    { path: '*', redirect: '/home' } 
  ]


})



router.beforeEach((to, from, next) => {
  console.log("\nbeforeEach \nfrom: "+from.path+"\nto: "+to.path+"\n\n")
  teras.router.from = from.path
  teras.router.to = to.path
  
  if(!teras.app.ready){    
     if(teras.ttl()){
        console.log("TTLCLEAR lancio appClear")
        teras.event.emit('appClear')
     }
     console.log("EFFETTUO LE OPERAZIONI AL PRIMO AVVIO DELLA APP "+ teras.name)
     teras.event.emit('routerFirst', to)
     return true
  }

  if (to.matched.some(record => record.meta.requiresAuth)){
     console.log("SONO RICHIESTI I PERMESSI..... LI CONTROLLO")
     if(teras.app.auth){
        console.log("....PERMESSI VERIFICATI, PROCEDO!")
        next()
     }else{
        console.log("....PERMESSI MANCANTI, LO MANDO A: "+teras.app.routeInitial)
        teras.event.emit('routerNoauth',to)
        next(teras.app.routeNoauth)
     }
  }else{
     console.log("NON SONO RICHIESTI PERMESSI")
     next()
  }

  teras.event.emit('routerChange', to)
})

export default router
